import React from "react";
import { SearchDeviceLoaderTemplate } from "../../../../themes/default/administration/device-menu/components";

function SearchDeviceLoader(props) {
    return <SearchDeviceLoaderTemplate {...props} />;
}

export default SearchDeviceLoader;
